<template>
	<div class="con">
		<div class="con1 fl_r fl_j_s fl_a_c" @click="godetails()">
			<img class="con1_l" src="../../assets/47.png" />
			<div class="con1_c">绍兴零工网</div>
			<div class="con1_r">找工作 来绍兴零工网</div>
			<!-- <div class="con1_rs">绍兴零工网</div> -->
		</div>
		<div class="con2">
			<div class="con2_info"> 绍兴零工网是一个为政府开办的零工市场配套的线上服务平台，跟线下零工市场同步联动，信息来源正规、真实、及时。全年免费为求职者提供求职介绍、劳动维权、政策咨询等服务，为用人单位提供招聘、调剂服务及免费政策咨询。 </div>
			<div class="con2_info"> 绍兴零工网特开设零工、家政服务和长期工的专用通道，尤其是对有零工和家政服务需求的用人单位、雇主和求职者，实行线上线下快速对接。 </div>
			<div class="con2_info"> 绍兴零工网现服务对接的线下零工市场有马鞍旺角零工市场、齐贤羊山零工市场、越城区城南零工市场。 有需要的用人单位和求职者可以关注“绍兴零工网”抖音官方号和公众号、或登录小程序“绍星零工网”，也可以到以上三家零工市场进行线下登记和咨询。 </div>
		</div>
		<div class="con3 fl_r fl_j_l fl_a_c">
			<div class="con3_i">
				<img class="con3_i_t" src="../../assets/8.jpg" />
				<div class="con3_i_b">公众号</div>
			</div>
			<div class="con3_i">
				<img class="con3_i_t" src="../../assets/9.png" />
				<div class="con3_i_b">抖音</div>
			</div>
			<div class="con3_i">
				<img class="con3_i_t" src="../../assets/10.jpg" />
				<div class="con3_i_b">微信小程序</div>
			</div>
		</div>
		<div class="con4">
			<div class="con4_info">联系电话：19883593176<span></span>0575-81199729</div>
		</div>
	</div>
</template>
<script>
	import axios from "axios";
	import footers from '@/components/footers.vue'
	export default {
		name: 'Detail',
		components: {
			footers,
		},
		data () {
			return {
				detail: {},
				details: {},
				id: '',
			}
		},
		mounted () {},
		methods: {
			godetails () {
				this.$router.push({ path: './' })
			},
			changesc (index) {
				this.scindex = index
			},
		},
	}
</script>
<style lang="less" scoped>
	.con4 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 50px;
		background-color: #2979ff;
		border-radius: 10px;
		padding-bottom: 30px;

		.con4_info {
			text-indent: 2ch;
			width: 1710px;
			margin: 0 auto;
			padding-top: 30px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-size: 30px;
			color: #fff;
			text-align: left;

			span {
				width: 100px;
				height: 20px;
				display: inline-block;
			}
		}
	}

	.con4_bsss {
		width: 1240px;
		margin: 0 auto;
		margin-top: 40px;

		.con4_bsss_t {
			width: 100%;

			.con4_bsss_t_i {
				margin-right: 60px;
				height: 60px;

				.con4_bsss_ts {
					font-family: Source Han Sans CN, Source Han Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #727273;
					line-height: 18px;
					text-align: left;
				}
			}

			.con4_bsss_t_i_active {
				.con4_bsss_ts {
					color: #12022F !important;
					font-size: 18px;
					font-weight: 500;
				}

				.con4_bsss_line {
					width: 34px;
					margin: 0 auto;
					margin-top: 8px;
					height: 2px;
					background: #000000;
					border-radius: 0px 0px 0px 0px;
				}
			}
		}

		.con4_bsss_b {
			width: 1240px;
			margin: 0 auto;
			margin-top: 30px;

			.con4_bsss_b_t {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 15px;
				color: #666567;
				line-height: 15px;
				text-align: left;
			}

			.con4_bsss_b_b {
				width: 1240px;
				margin: 0 auto;
				margin-top: 20px;

				.con4_bsss_b_b_l {
					width: 1240px;
					height: 575px;
				}
			}
		}
	}

	.con3 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 50px;
		background-color: #fff;
		border-radius: 10px;
		padding-bottom: 30px;

		.con3_i {
			width: 200px;
			margin-right: 50px;
			margin-top: 30px;

			.con3_i_t {
				width: 200px;
				height: 200px;
				display: block;
			}

			.con3_i_b {
				color: #333;
				font-size: 20px;
				width: 100%;
				text-align: center;
				padding-top: 30px;
			}
		}
	}

	.con2 {
		width: 1240px;
		margin: 0 auto;
		margin-top: 50px;
		background-color: #fff;
		border-radius: 10px;
		padding-bottom: 30px;

		.con2_info {
			text-indent: 2ch;
			width: 1200px;
			margin: 0 auto;
			padding-top: 30px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-size: 24px;
			color: #4E4E4E;
			text-align: left;
		}
	}

	.con {
		width: 100%;
		background: url('../../assets/43.png') no-repeat;
		background-size: 100%;
		min-height: 100vh;
		background-color: #F5FCF9;
	}

	.con1 {
		width: 100%;
		height: 81px;
		background: #111111;

		.con1_l {
			width: 38px;
			height: 38px;
			display: block;
			margin-left: 58px;
		}

		.con1_c {
			font-family: Inter, Inter;
			font-size: 32px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 9px;
		}

		.con1_r {
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 81px;
			padding-left: 7px;
			padding-top: 10px;
		}

		.con1_rs {
			width: 120px;
			height: 40px;
			font-size: 20px;
			text-align: center;
			line-height: 40px;
			background-color: #fff;
			color: #000;
			border-radius: 10px;
			margin-left: 80px;
			cursor: pointer;
		}
	}
</style>